import { useState } from "react";
import { Daily } from "./components/Daily";
import { Weekly } from "./components/Weekly";
import axios from "axios";
import moment from "moment";
import "moment-timezone";

type View = "daily" | "weekly";

const App = () => {
  const parsingDateFormat = "MMDDYYYY HH:mm";
  const timezone = "America/New_York"; // eastern
  const [selectedView, setSelectedView] = useState<View>("daily");
  const client = axios.create({
    baseURL:
      "https://wagerapi.saratogabets.com/api/SimulcastSchedule/Get",
  });

  const getLocalDate = (runDate: string, time: string) => {
    return moment
      .tz(runDate + " " + time, parsingDateFormat, timezone)
      .local()
      .format("hh:mm a");
  };

  let view;
  if (selectedView === "weekly") {
    view = <Weekly setSelectedView={setSelectedView} client={client} getLocalDate={getLocalDate} />;
  } else {
    view = <Daily setSelectedView={setSelectedView} client={client} getLocalDate={getLocalDate} />;
  }

  return <div>{view}</div>;
};

export default App;
